import { markRaw } from 'vue'
import _ from 'lodash'

import Table from '../components/table.vue'
import Form from '../components/form.vue'
import LoginForm from '../components/loginform.vue'
import RegisterForm from '../components/registerform.vue'
import Row from '../components/row.vue'
import Column from '../components/column.vue'
import Chart from '../components/chart.vue'
import Pivot from '../components/pivot.vue'
import CustomView from '../components/custom.vue'
import RichTextView from '../components/richtext.vue'
import StaticImageView from '../components/staticimage.vue'
import { assignColumnFormat } from '../../../shared/column-format'
import { copySubmissionConfig } from '../../../shared/submission-redirect'
import { assignPresetFilterProps } from './preset-filter-state'

const componentMap = {
  table: Table,
  pivot: Pivot,
  custom: CustomView,
  form: Form,
  login: LoginForm,
  registration: RegisterForm,
  row: Row,
  column: Column,
  chart: Chart,
  richtext: RichTextView,
  staticimage: StaticImageView
}

let noUniqueTitleCounter = 0

function instantiatePageComponent (component, context) {

  const pageUniqueTitle = (context && context.pageUniqueTitle) || ''
  const accessKey = context && context.accessKey

  console.log(`loading component ${component.type} / ${component.uniqueTitle}!`)

  const instantiatedComponent = _.cloneDeep(componentMap[component.type])

  if (!instantiatedComponent) return null

  if (!component.uniqueTitle) {

    component.uniqueTitle = `component_without_unique_title_${noUniqueTitleCounter++}`
  }

  instantiatedComponent.uniqueTitle = component.uniqueTitle
  instantiatedComponent.titleValue = component.title || ''

  if (component.type === 'form' || component.type === 'login' || component.type === 'registration' || component.type === 'row' || component.type === 'column') {

    instantiatedComponent.formComponents = component.components
  }

  assignColumnFormat(instantiatedComponent, component)
  copySubmissionConfig(instantiatedComponent, component)

  if (component.type === 'form') {

    if (accessKey && component.isEditForm === true) {

      instantiatedComponent.isEditForm = true
    }
  }

  if (component.type === 'table') {

    instantiatedComponent.items = component.items
    instantiatedComponent.userFilteringValue = !!component.userFiltering
    instantiatedComponent.pageUniqueTitleValue = pageUniqueTitle
    instantiatedComponent.componentUniqueTitleValue = component.uniqueTitle
    instantiatedComponent.realtimeValue = !!component.realtime
    instantiatedComponent.csvExportValue = !!component.csvExport
    instantiatedComponent.tableLayoutValue = component
    instantiatedComponent.searchEnabledValue = component.searchEnabled === true || component.searchEnabled === 'true'
    instantiatedComponent.spreadSheetUniqueTitleValue = component.spreadSheet || ''
  }

  if (component.type === 'chart') {

    instantiatedComponent.chartTypeValue = component.chartType || 'bar'
    instantiatedComponent.titleValue = component.title || ''
    instantiatedComponent.userFilteringValue = !!component.userFiltering
    instantiatedComponent.pageUniqueTitleValue = pageUniqueTitle
    instantiatedComponent.componentUniqueTitleValue = component.uniqueTitle
    instantiatedComponent.realtimeValue = !!component.realtime
    instantiatedComponent.spreadSheetUniqueTitleValue = component.spreadSheet || ''
  }

  if (component.type === 'pivot') {

    instantiatedComponent.titleValue = component.title || ''
    instantiatedComponent.userFilteringValue = !!component.userFiltering
    instantiatedComponent.pageUniqueTitleValue = pageUniqueTitle
    instantiatedComponent.componentUniqueTitleValue = component.uniqueTitle
    instantiatedComponent.realtimeValue = !!component.realtime
    instantiatedComponent.searchEnabledValue = component.searchEnabled === true || component.searchEnabled === 'true'
    instantiatedComponent.defaultUserFiltersValue = component.defaultUserFilters || []
    instantiatedComponent.defaultUserFilterMatchModeValue = component.defaultUserFilterMatchMode || 'all'
    instantiatedComponent.restrictUserFilteringValue = !!component.restrictUserFiltering
    instantiatedComponent.spreadSheetUniqueTitleValue = component.spreadSheet || ''
    instantiatedComponent.pivotConfigValue = {
      rowFields: component.rowFields || [],
      columnFields: component.columnFields || [],
      valueFields: component.valueFields || [],
      showSubtotals: component.showSubtotals,
      showRowGrandTotal: component.showRowGrandTotal,
      showColumnGrandTotal: component.showColumnGrandTotal
    }
  }

  if (component.type === 'custom') {

    instantiatedComponent.titleValue = component.title || ''
    instantiatedComponent.userFilteringValue = !!component.userFiltering
    instantiatedComponent.pageUniqueTitleValue = pageUniqueTitle
    instantiatedComponent.componentUniqueTitleValue = component.uniqueTitle
    instantiatedComponent.realtimeValue = !!component.realtime
    instantiatedComponent.searchEnabledValue = component.searchEnabled === true || component.searchEnabled === 'true'
    instantiatedComponent.defaultUserFiltersValue = component.defaultUserFilters || []
    instantiatedComponent.defaultUserFilterMatchModeValue = component.defaultUserFilterMatchMode || 'all'
    instantiatedComponent.restrictUserFilteringValue = !!component.restrictUserFiltering
    instantiatedComponent.spreadSheetUniqueTitleValue = component.spreadSheet || ''
    instantiatedComponent.viewCodeValue = component.viewCode || ''
    instantiatedComponent.viewCssValue = component.viewCss || ''
  }

  if (component.type === 'richtext') {

    instantiatedComponent.richTextContentValue = component.richTextContent || ''
  }

  if (component.type === 'staticimage') {

    instantiatedComponent.staticImageIdValue = component.staticImageId || null
    instantiatedComponent.altTextValue = component.altText || ''
    instantiatedComponent.titleValue = component.title || ''
  }

  assignPresetFilterProps(instantiatedComponent, component)

  console.log(`push ${component.uniqueTitle} / ${instantiatedComponent.uniqueTitle}`)

  return markRaw(instantiatedComponent)
}

export { instantiatePageComponent }
